import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "GROW Investment Group"
          }
        },
        {
          path: "/team-intro",
          name: "teamIntro",
          component: resolve => require(["@/view/team-intro"], resolve),
          meta: {
            title: "Shareholders & Team"
          }
        },
        {
          path: "/multi-assets",
          name: "MultiAsseets",
          component: resolve => require(["@/view/multi-assets"], resolve),
          meta: {
            title: "MULTI STRATEGY"
          }
        },
        {
          path: "/credit-property",
          name: "CreditProperty",
          component: resolve => require(["@/view/credit-property"], resolve),
          meta: {
            title: "REAL ESTATE INVESTMENT"
          }
        },

        {
          path: "/multi-family",
          name: "MultiFamily",
          component: resolve => require(["@/view/multi-family"], resolve),
          meta: {
            title: "MULTI FAMILY OFFICE"
          }
        },
        {
          path: "/company-option",
          name: "CompanyOption",
          component: resolve => require(["@/view/company-option"], resolve),
          meta: {
            title: "INSIGHTS"
          }
        },

        {
          path: "/company-news",
          name: "CompanyNews",
          component: resolve => require(["@/view/company-news"], resolve),
          meta: {
            title: "NEWS"
          }
        },

        {
          path: "/company-news-detail",
          name: "CompanyNewsDetail",
          component: resolve => require(["@/view/company-news-detail"], resolve),
          meta: {
            title: "NEWS"
          }
        },

        {
          path: "/company-option-detail",
          name: "CompanyNewsDetail",
          component: resolve => require(["@/view/company-option-detail"], resolve),
          meta: {
            title: "RESEARCH"
          }
        },

        {
          path: "/company-honor",
          name: "CompanyHonor",
          component: resolve => require(["@/view/company-honor"], resolve),
          meta: {
            title: "CORPORATE HONORS"
          }
        },



        {
          path: "/contact-us",
          name: "ContactUs",
          component: resolve => require(["@/view/contact-us"], resolve),
          meta: {
            title: "CONTACT US"
          }
        },

        {
          path: "/join-us",
          name: "JoinUs",
          component: resolve => require(["@/view/join-us"], resolve),
          meta: {
            title: "JOIN US"
          }
        },

        {
          path: "/company-research",
          name: "CompanyResearch",
          component: resolve => require(["@/view/company-research"], resolve),
          meta: {
            title: "GROW Research"
          }
        },

        {
          path: "/company-research-detail",
          name: "CompanyResearchDetail",
          component: resolve => require(["@/view/company-research-detail"], resolve),
          meta: {
            title: "GROW RESEARCH"
          }
        },
        {
          path: "/outside-assets",
          name: "OutsideAssets",
          component: resolve => require(["@/view/outside-assets"], resolve),
          meta: {
            title: "SHAREHOLDERS"
          }
        },





        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "软件产品"
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown"
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: resolve =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "软件产品丨智能小镇管理系统"
              }
            },
            {
              path: "/software/bigData",
              name: "software",
              component: resolve =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "软件产品丨大数据管理系统"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        },




      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js